var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-flex",
        [
          _c(
            "v-form",
            {
              on: {
                input: function($event) {
                  return _vm.$emit("validForm", _vm.validForm)
                }
              },
              model: {
                value: _vm.validForm,
                callback: function($$v) {
                  _vm.validForm = $$v
                },
                expression: "validForm"
              }
            },
            [
              _c(
                "v-container",
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", [
                        _c(
                          "h2",
                          {
                            staticClass: "h2_title",
                            staticStyle: { "margin-top": "12px !important" }
                          },
                          [_vm._v("\n              General\n            ")]
                        )
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              name: "movimiento",
                              label: _vm.formFields.movimiento.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.movimiento.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.movimiento,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.movimiento.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:80",
                                expression: "'max:80'"
                              }
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.usuario.label,
                              disabled: true,
                              counter: 80
                            },
                            model: {
                              value: _vm.formFields.usuario.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.usuario, "value", $$v)
                              },
                              expression: "formFields.usuario.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.operacion.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.operacion.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.operacion, "value", $$v)
                              },
                              expression: "formFields.operacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.origen.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.origen.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.origen, "value", $$v)
                              },
                              expression: "formFields.origen.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.destino.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.destino.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.destino, "value", $$v)
                              },
                              expression: "formFields.destino.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.estado.label,
                              items: _vm.estados,
                              disabled: true,
                              "item-text": "configvalor",
                              "item-value": "configid"
                            },
                            model: {
                              value: _vm.formFields.estado.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.estado, "value", $$v)
                              },
                              expression: "formFields.estado.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.fechaAlta.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.fechaAlta.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.fechaAlta, "value", $$v)
                              },
                              expression: "formFields.fechaAlta.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.fechaRecepcion.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.fechaRecepcion.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaRecepcion,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.fechaRecepcion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.caja.label,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.caja.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.caja, "value", $$v)
                              },
                              expression: "formFields.caja.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              clearable: "",
                              label: _vm.formFields.despacho.label,
                              items: _vm.despachos,
                              "item-text": "despaseguimiento",
                              "item-value": "despanumero",
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.despacho.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.despacho, "value", $$v)
                              },
                              expression: "formFields.despacho.value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.formFields.despacho.value != ""
                        ? _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  label: _vm.formFields.receptor.label,
                                  disabled:
                                    !_vm.esEdicion ||
                                    _vm.edited.despareceptor != "",
                                  rules: [_vm.rules.required]
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$emit(
                                      "receptor",
                                      _vm.formFields.receptor.value
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.formFields.receptor.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.receptor,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.receptor.value"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:250",
                                expression: "'max:250'"
                              }
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.observacion.label,
                              counter: 250,
                              disabled: true
                            },
                            model: {
                              value: _vm.formFields.observacion.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.observacion,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.observacion.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.esEdicion &&
          _vm.formFields.despacho.value != "" &&
          _vm.edited.despareceptor == ""
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-grabar white--text",
                  attrs: { depressed: "", disabled: !_vm.validForm },
                  on: {
                    click: function($event) {
                      _vm.$emit("edicion", true)
                      _vm.$emit("textoModal", _vm.textoConDespacho)
                    }
                  }
                },
                [_vm._v("Guardar Cambios")]
              )
            : _vm.esEdicion && _vm.edited.moviestado != _vm.recibido
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-grabar white--text",
                  attrs: { depressed: "" },
                  on: {
                    click: function($event) {
                      _vm.$emit("edicion", true)
                      _vm.$emit("textoModal", _vm.textoSinDespacho)
                    }
                  }
                },
                [_vm._v("Confirmar Recepción")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }